<template>
<div class="welcome_message">
    <!-- <h2>Welcome Kumar P!</h2> -->
        <div class="welcome_cnt">
          {{ accessError }}           
        </div>
        <div class="welcome_thanks" v-if="tenantName">
            <p>Thank you</p>    
            <!-- <span v-if="checkProperty(getUserData, 'tenantDetails', 'name')">{{checkProperty(getUserData, 'tenantDetails', 'name')}} Team</span> -->
             <span>{{tenantName}} Team</span>
        </div>
</div>
</template>
 
<script>
 
 
  export default {
    components: {
    },
    data() {
      return {
      };
    },
    methods: {
    },
    mounted() {
    },
    props:{
      accessError:{
        type:String,
        default:''
      },
      tenantName:{
        type:String,
        default:''
      },
    }
  };
</script>
 